import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["image"]

  preview(event) {
    const file = event.target.files[0]
    if (!file) return

    this.disconnect()
    this.previewUrl = URL.createObjectURL(file)
    this.imageTarget.src = this.previewUrl
    this.imageTarget.hidden = false
  }

  disconnect() {
    if (this.previewUrl) URL.revokeObjectURL(this.previewUrl)
    this.previewUrl = null
  }
}
